import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

const Styled = {};

Styled.BodyWrapper = styled.div`
  background: #e5e5e5;
  padding: 43px 62px 0;
  width: 100%;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 2;
`;

Styled.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #000;
  padding-right: 20px;
`;

Styled.SubmitDecisionButton = styled.div`
  display: inline-block;
  height: 23px;
  width: 148px;
  line-height: 23px;
  text-align: center;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
  background-color: ${({ submitted }) =>
    submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)"};
  border-radius: 5px;

  .fa-spinner,
  .fa-check {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
  }
`;

Styled.ButtonsWrapper = styled.div`
  padding: 0 2px;
`;

Styled.ButtonsWrapperFlex = styled.div`
  display: flex;
  align-items: center;
`;

Styled.UIButton = styled(({ isSmaller, ...props }) => <Button {...props} />)`
  display: block;
  padding: 0 !important;
  min-width: auto !important;
  border-color: transparent !important;
  width: 156px !important;
  height: 43px !important;
  line-height: 43px !important;
  background-color: #2a4169 !important;
  font-family: Lato !important;
  font-weight: bold !important;
  font-size: 14px !important;
  color: #fff !important;
  border-radius: 4px !important;
  transition: background-color 0.5s ease;

  ${p =>
    p.isSmaller &&
    `
    font-size: 18px !important;
    width: 139px !important;
    height: 30px !important;
    line-height: 30px !important;
  `}

  &:hover {
    background-color: #0da6ad !important;
  }

  &:disabled {
    background-color: #cccccc !important;
  }

  &.active {
    background-color: #0da6ad !important;
  }
`;

Styled.Arrow = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`;

Styled.CashBalanceRow = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
`;

Styled.CashBalanceTitle = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #000;
  padding-right: 15px;
`;

Styled.WhiteBlock = styled.div`
  background: #fff;
  width: 100%;
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 800px;
  padding: 25px 40px 60px;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
`;

Styled.Title1 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

Styled.Title2 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;
  margin-top: 40px;
  display: flex;
  align-items: center;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }
`;

Styled.HelpIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  cursor: pointer;
`;

Styled.ModalVideoWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3A507B;
  border-radius: 10px;

  &:before {
    display: block;
    content: '';
    align-items: center;
    background: #0006;
    display: flex;
    justify-content: center;
    opacity: 1;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transition: opacity .3s ease;
    border-radius: 10px;
  }

  &.is-playing:before, &.is-playing button {
    opacity: 0;
  }
  &.is-playing:hover:before, &.is-playing:hover button {
    opacity: 1;
  }
  &:hover video {
    cursor: pointer;
  }
`;

Styled.PlayPauseButton = styled.button`
  align-items: center;
  background: none;
  background: #2a4169;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #0000001a;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 2rem;
  height: 80px;
  justify-content: center;
  padding: 0;
  text-align: center;
  width: 80px;
  z-index: 2;
  position: absolute;
  transition: opacity .3s ease;
  opacity: 1;
`;

Styled.CloseModalVideoButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: #fff;
  padding: 0;
  line-height: normal;
`;

Styled.AmountsRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 34px;
`;

Styled.AmountsColumn1 = styled.div``;
Styled.AmountsColumn2 = styled.div`
  padding-left: 40px;
`;

Styled.Title3 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;
  display: flex;
  align-items: center;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }
`;

Styled.Title4 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }
`;

Styled.Amount = styled.div`
  padding-top: 15px;
  font-family: Lato;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #000;
  text-align: center;
  display: none;

  ${p =>
    p.shown &&
    `
    display: block;
  `}

  ${p => p.negative && `
    color: #ff4d4f;
  `}
`;

Styled.Chart = {};

Styled.Chart.Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
  z-index: 1;
`;

Styled.Chart.Chart = styled.div`
  flex: 0 0 408px;
`;

Styled.Chart.Legend = styled.div`
  margin-top: -10px;
`;

Styled.Chart.LegendItem = styled.div`
  font-family: Lato;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
  display: flex;
  align-items: center;
  margin-top: 10px;

  ${p =>
    p.bold &&
    `
    font-weight: bold;
  `}
`;

Styled.Chart.LegendItemCircle = styled.div`
  width: 15px;
  height: 15px;
  ${p =>
    p.color &&
    `
    background: ${p.color};
  `};
  margin-right: 13px;
  content: "";
  border-radius: 15px;
`;



export default Styled;



// WEBPACK FOOTER //
// ./src/components/finance/style.js